
import { Component, Vue } from 'vue-property-decorator';
import {
  EmployeeLeavesInterface, EmployeeYearPanelInterface,
  LeaveRequestInterface,
  LeavesRepositoryInterface,
  UsedLeaveTypesCountsInterface,
} from '@/services/Calendar/leaves/interfaces';
import {
  BaseProfileDataInterface,
  ProfileInterface,
  ProfileRepositoryInterface,
} from '@/services/Users-profile/interfaces';
import Themeable from 'vuetify/lib/mixins/themeable';
import ViewLeaveRequestDialog from '@/components/dialogs/calendar/leave/ViewLeaveRequestDialog.vue';
import LeaveCountsComponent from '@/views/pages/calendar/leaves/components/LeaveCountsComponent.vue';
import UpcomingLeavesComponent from '@/views/pages/calendar/leaves/components/UpcomingLeavesComponent.vue';
import RecentLeavesComponent from '@/views/pages/calendar/leaves/components/RecentLeavesComponent.vue';

@Component({
  mixins: [
    Themeable,
  ],
  components: {
    ViewLeaveRequestDialog,
    LeaveCountsComponent,
    UpcomingLeavesComponent,
    RecentLeavesComponent,
  },
  inject: [
    'leavesRepository',
    'profileRepository',
  ],
})
export default class MyLeaves extends Vue {
  private leavesRepository: LeavesRepositoryInterface;
  private profileRepository!: ProfileRepositoryInterface;

  private loading: boolean = true;

  private profile!: ProfileInterface;
  private leaves: LeaveRequestInterface[] = [];
  private usedLeaveTypes: UsedLeaveTypesCountsInterface[] = [];
  private upcomingLeaves: LeaveRequestInterface[] = [];
  private usersMap: { [userId: string]: BaseProfileDataInterface } = {};
  private employeeLeaves!: EmployeeLeavesInterface;
  private employeeYearPanel!: EmployeeYearPanelInterface;

  private currentPage: number = 1;
  private totalItems: number = 0;
  private currentYear: number = new Date().getFullYear();

  private async created(): Promise<void> {
    [this.leaves, this.totalItems] = await this.leavesRepository
      .getAllUserLeaves(this.$store.getters.id, this.currentPage);

    this.upcomingLeaves = await this.leavesRepository.getUserUpcomingLeaves(this.$store.getters.id);

    this.usedLeaveTypes = await this.leavesRepository.getUsedLeaveTypesCounts(this.$store.getters.id);

    this.profile = await this.profileRepository.getOneByUserId(this.$store.getters.id);

    this.employeeLeaves = await this.leavesRepository.getEmployeeLeaves(this.$store.getters.id);

    this.employeeYearPanel = await this.leavesRepository.getEmployeeYearPanel(this.$store.getters.id, this.currentYear);

    await this.getUsersProfileData(this.leaves);
    this.loading = false;
  }

  private async getUsersProfileData(leaves: LeaveRequestInterface[]): Promise<void> {
    const usersIds: string[] = [];
    leaves.forEach((leave) => {
      if (!usersIds.includes(leave.requestBy)) {
        usersIds.push(leave.requestBy);
      }
      if (!!leave.reviewedBy && !usersIds.includes(leave.reviewedBy)) {
        usersIds.push(leave.reviewedBy);
      }
    });

    const usersProfiles = await this.profileRepository.getBaseProfileDataByUsersIds(usersIds);
    usersProfiles.forEach((profile) => {
      this.usersMap[profile.userId] = profile;
    });
  }

  private async changePage(page: number): Promise<void> {
    this.currentPage = page;
    const [leaves, totalItems] = await this.leavesRepository
      .getAllUserLeaves(this.$store.getters.id, this.currentPage);

    await this.getUsersProfileData(leaves);

    this.leaves = leaves;
    this.totalItems = totalItems;
  }
}
